<template>
    <div class="main-box mh-a pv18 partner-page">
        <iristar-dividing> {{ $t("title.title2") }} </iristar-dividing>
        <div class="partner-box">
            <div class="flex1">
                <div class="partner-title">
                    <h3>医药行业</h3>
                    <div class="line"></div>
                </div>


                <div class="partner-container flex" style="flex-flow: row wrap;
                    align-content: center;
                    justify-content: center;
                    align-items: center;">
                    <div style="flex:0 0 33.3%;" v-for="i in   9  " :key="`${i}_partner`">
                        <div class="partner-item">
                            <div class="img-content">
                                <img :src="`./static/img/partner/${i}.png`">
                            </div>

                        </div>

                    </div>
                </div>

            </div>
            <div class="flex1">
                <div class="partner-title">
                    <h3>企事业单位</h3>
                    <div class="line"></div>
                </div>
                <div class="partner-container flex" style="flex-flow: row wrap;
                    align-content: center;
                    justify-content: center;
                    align-items: center;">
                    <div style="flex:0 0 33.3%;" v-for="i in   9  " :key="`${i}_partner`">
                        <div class="partner-item">
                            <div class="img-content">
                                <img :src="`./static/img/partner/${i + 9}.png`">
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IristarDividing from "@/components/IristarDividing";
export default {
    name: "IristarPartner",
    components: {
        IristarDividing,
    },
};
</script>

<style lang="less">
.partner-box {
    .partner-title {
        position: relative;

        .line {
            position: absolute;
            height: 1px;
            width: 100%;
            top: 50%;
            // background-color: rgb(91, 155, 213);
        }

        margin:0 50px;

        text-align: center;

        h3 {
            position: relative;
            z-index: 2;
            display: inline-block;
            background: #fff;
        }
    }


    .partner-item {
        margin: 10px;
        position: relative;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        padding-bottom: 53%;
        height: 0;

        .img-content {
            position: absolute;
            left: 0;
            top: 0;
            padding: 5px;
            display: flex;
            justify-content: center;
            align-content: center;
            align-items: center;
            width: 100%;
            border: 1px solid #ccc;
            height: 100%;

            img {
                max-height: 100%;
            }


        }
    }
}

@media (min-width: 768px) {
    .partner-box {
        display: flex;
        gap: 50px;

    }

}
</style>